
/** @param {import('@runeya/common-typings').Runeya} runeya */
const NodeRed = (runeya) => {
  
}

module.exports = NodeRed